<template>    
<div id="AddPessoa" class="container small">
  <div class="title">
     <h3><router-link class="btn btn-default" :to="{ name: 'ListPessoas' }"><i class="fa fa-angle-left"></i> Voltar à Lista</router-link>&nbsp;Cadastro de Pessoas</h3>
  </div> 
  <form id="pessoaForm" v-on:submit.prevent="add">
    <p class="alert alert-danger" v-if="errors.length">
      <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
      <ul>
        <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
      </ul>
    </p>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>ID Interno</label>
        <input type="number" class="form-control form-control" v-model="newPessoa.idinterno">
      </div>
      <div class="form-group col-md-3">
        <label>Status</label>
        <v-select :options="status" 
                            v-model="newPessoa.status" 
                            label="descricao" 
                            value="{ idstatus : id, descricao : descricao }"></v-select>
      </div>
    </div>
    <div class="form-row">

    </div>
    <div v-if="newPessoa.id" class="form-group">
      <label>Data Cadastro</label>
      <input type="date" class="form-control form-control" v-model="newPessoa.data_cadastro" readonly>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Nome\Razão Social</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.nome_razao">
      </div>
      <div class="form-group col-md-6">
        <label>Fantasia</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.fantasia">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>CNPJ\CPF</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.cnpj_cpf" v-mask="['###.###.###-##', '##.###.###/####-##']">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label>Logradouro</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.logradouro">
      </div>
      <div class="form-group col-md-2">
        <label>Número</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.numero">
      </div>
      <div class="form-group col-md-4">
        <label>Bairro</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.bairro">
      </div>
    </div>
    <div class="form-row">          
      <div class="form-group col-md-6">
        <label>Complemento</label>
        <input type="text" class="form-control form-control" v-model="newPessoa.complemento">
      </div>
      <div class="form-group col-md-2">
        <label>UF</label>
        <v-select  :options="estados"
                   v-model="parseCidades"
                   @input="getCidades"
                   value="cidades"
                   label="sigla"></v-select>
      </div>
      <div class="form-group col-md-4">
        <label>Cidades</label>
        <v-select :options="cidades"
                  v-model="newPessoa.cidade.municipio"></v-select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Unidade de Negocio</label>
        <v-select :options="unid_neg" 
                    v-model="newPessoa.unid_neg" 
                    label="descricao" 
                    value="{ idunid_neg : id, descricao : descricao }">
        </v-select>              
      </div>
      <div class="form-group col-md-3">
        <label>Tipo</label>
        <v-select :options="tipo" 
                    v-model="newPessoa.tipo" 
                    label="descricao" 
                    value="{ idtipo : id, descricao : descricao }">
        </v-select>
      </div>
      <div class="form-group col-md-3">
        <label>Cargo</label>
        <v-select :options="cargo" 
                    v-model="newPessoa.cargo" 
                    label="descricao" 
                    value="{ idcargo : id, descricao : descricao }">
        </v-select>
      </div>
    </div>
    <div class="modal-footer">
      <slot name="footer">
        <button class="btn btn-primary" type="submit">Salvar</button>
        <!--<button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Cancelar</button>-->
      </slot>
    </div>
  </form>
</div>
</template>
<script>

import vSelect from 'vue-select'
import { estados } from '../../config/estados-cidades.js';
import moment from 'moment'

const fb = require('../../config/db.js')

export default {
  name: 'AddPessoa',
  props:["pessoa1"],
  components: {
    vSelect
  },
  data(){
    return {
      unid_neg: [],
      status: [{idstatus: 1, descricao: 'Ativo'}, {idstatus: 2, descricao: 'Inativo'}],
      regiao: [],
      estados: [],
      parseCidades: [],
      cidades: [],
      ufs: [],
      cargo: [],
      tipo: [],
      errors: [],
      parametro: null,
      error: false,
      msgError: [],
      newPessoa: {
        'unid_neg' : { 'idunid_neg' : "", 'descricao' : '' }, 
        'status' : {'idstatus' : "", 'descricao': "" }, 
        'idinterno' : "", 
        'data_cadastro' : "", 
        'usuario_cadastro' : '', 
        'data_alteracao' : '', 
        'usuario_alteracao' : '', 
        'nome_razao' : "", 
        'fantasia' : "", 
        'cnpj_cpf' : "", 
        'regiao' : { 'idregiao' : "", 'descricao' : '' }, 
        'logradouro' : "", 
        'numero' : "", 
        'bairro' : "", 
        'complemento' : "", 
        'cidade' : { 'uf' : "", 'municipio' : '' }, 
        'cargo' : { 'idcargo' : "", 'descricao' : '' },  
        'tipo' : { 'idtipo' : "", 'descricao' : '' }, 
      },
    }
  },
  created() {
    if (this.$route.params.pessoa_id)
      this.getPessoa();
    this.getFormsData();
  },  
  methods: {
    getPessoa(){
      fb.Pessoas.doc(this.$route.params.pessoa_id).onSnapshot(p => {
        this.newPessoa = p.data();
        this.newPessoa.data_cadastro = moment(new Date(this.newPessoa.data_cadastro.seconds * 1000).toString()).format('YYYY-MM-DD')
        this.newPessoa.id = p.id;
      });
    },
    getCidades(){
      this.newPessoa.cidade.uf = this.parseCidades.sigla;
      this.cidades = this.parseCidades.cidades;
    },
    getFormsData(){
      this.estados = estados;
      fb.UnidadesNegocios.get().then(querySnapshot =>{
        const objects = []
        const objectsArray = []
        let i = 0
        querySnapshot.forEach((doc)=>{
          objectsArray.push(doc.data())
          objectsArray[i].idunid_neg = doc.id
          objects.push(objectsArray[i])
          i++
        });
        this.unid_neg = objects;
      });
      fb.RegioesVendas.get().then(querySnapshot =>{
        const objects = []
        const objectsArray = []
        let i = 0
        querySnapshot.forEach((doc)=>{
          objectsArray.push(doc.data())
          objectsArray[i].idregiao = doc.id
          objects.push(objectsArray[i])
          i++
        });
        this.regiao = objects;
      });
      fb.CargosFuncoes.get().then(querySnapshot =>{
        const objects = []
        const objectsArray = []
        let i = 0
        querySnapshot.forEach((doc)=>{
          objectsArray.push(doc.data())
          objectsArray[i].idcargo = doc.id
          objects.push(objectsArray[i])
          i++
        });
        this.cargo = objects;
      });
      fb.TiposPessoas.get().then(querySnapshot =>{
        const objects = []
        const objectsArray = []
        let i = 0
        querySnapshot.forEach((doc)=>{
          objectsArray.push(doc.data())
          objectsArray[i].idtipo = doc.id
          objects.push(objectsArray[i])
          i++
        });
        this.tipo = objects;
      });
    },
    add() {
      this.errors = [];
      if (!this.newPessoa.nome_razao && !this.newPessoa.fantasia)
        this.errors.push('O Razão/Fantasia é obrigatório');
      
      if (!this.newPessoa.status.descricao)
        this.errors.push('O Status é obrigatório');
      
      if (!this.newPessoa.cidade.uf)
        this.errors.push('A UF é obrigatório');
      
      if (!this.newPessoa.cidade.municipio)
        this.errors.push('A Cidade é obrigatório');
      
      if (!this.newPessoa.unid_neg.descricao)
        this.errors.push('A Unidade de Negócio é obrigatório');
      
      if (!this.newPessoa.cargo.descricao)
        this.errors.push('O Cargo é obrigatório');
      
      if (!this.newPessoa.tipo.descricao)
        this.errors.push('O Tipo é obrigatório');
      
      if (this.errors.length)
        return;
      
      if (this.newPessoa.id){
        fb.Pessoas.doc(this.newPessoa.id).update({
          'unid_neg' :  { 'idunid_neg' : this.newPessoa.unid_neg.idunid_neg, 'descricao' :  this.newPessoa.unid_neg.descricao }, 
          'status' : { 'idstatus' : this.newPessoa.status.idstatus, 'descricao' :  this.newPessoa.status.descricao }, 
          'idinterno' : this.newPessoa.idinterno, 
          'data_alteracao' : new Date(), 
          'usuario_alteracao' : fb.auth.currentUser.email, 
          'nome_razao' : this.newPessoa.nome_razao, 
          'fantasia' : this.newPessoa.fantasia, 
          'cnpj_cpf' : this.newPessoa.cnpj_cpf, 
          'regiao' :  { 'idregiao' : this.newPessoa.regiao.idregiao, 'descricao' :  this.newPessoa.regiao.descricao }, 
          'logradouro' : this.newPessoa.logradouro, 
          'numero' : this.newPessoa.numero, 
          'bairro' : this.newPessoa.bairro, 
          'complemento' : this.newPessoa.complemento, 
          'cidade' :  { 'uf' : this.newPessoa.cidade.uf, 'municipio' :  this.newPessoa.cidade.municipio }, 
          'cargo' :  { 'idcargo' : this.newPessoa.cargo.idcargo, 'descricao' :  this.newPessoa.cargo.descricao }, 
          'tipo' :  { 'idtipo' : this.newPessoa.tipo.idtipo, 'descricao' :  this.newPessoa.tipo.descricao }, 
        });
      }else{
        fb.Pessoas.add({
          'unid_neg' :  { 'idunid_neg' : this.newPessoa.unid_neg.idunid_neg, 'descricao' :  this.newPessoa.unid_neg.descricao }, 
          'status' : { 'idstatus' : this.newPessoa.status.idstatus, 'descricao' :  this.newPessoa.status.descricao }, 
          'idinterno' : this.newPessoa.idinterno, 
          'data_cadastro' : new Date(), 
          'usuario_cadastro' : fb.auth.currentUser.email, 
          'nome_razao' : this.newPessoa.nome_razao, 
          'fantasia' : this.newPessoa.fantasia, 
          'cnpj_cpf' : this.newPessoa.cnpj_cpf, 
          'regiao' :  { 'idregiao' : this.newPessoa.regiao.idregiao, 'descricao' :  this.newPessoa.regiao.descricao }, 
          'logradouro' : this.newPessoa.logradouro, 
          'numero' : this.newPessoa.numero, 
          'bairro' : this.newPessoa.bairro, 
          'complemento' : this.newPessoa.complemento, 
          'cidade' :  { 'uf' : this.newPessoa.cidade.uf, 'municipio' :  this.newPessoa.cidade.municipio }, 
          'cargo' :  { 'idcargo' : this.newPessoa.cargo.idcargo, 'descricao' :  this.newPessoa.cargo.descricao }, 
          'tipo' :  { 'idtipo' : this.newPessoa.tipo.idtipo, 'descricao' :  this.newPessoa.tipo.descricao }, 
          'del' : 'n',
          'usuario_del': '',
          'data_del': ''
        });
      }
     
      this.$emit('list-closeModal');
      this.$router.push('/pessoas');
    },
    closeModal(event){
      event.preventDefault();
      this.$emit('list-closeModal');
    },
    onParametro(parametro){
      this.parametro = parametro;
    }
  },
  firestore: function() {
    
  }
}
</script>
<style scoped>
  .title {
    margin-top: 24px;
    margin-bottom: 32px;
  }
</style>


